import api from "./api";

export const getUsers = async (params = {}) => {
  const response = await api.get("users/", { params });
  return response.data;
};

export const getUserById = async (id) => {
  const response = await api.get(`users/${id}/`);
  return response.data;
};

export const createUser = async (data) => {
  const response = await api.post("users/", data);
  return response.data;
};

export const updateUser = async (id, data) => {
  const response = await api.patch(`users/${id}/`, data);
  return response.data;
};

export const deleteUser = async (id, password) => {
  await api.delete(`users/${id}/`, { data: { password }, params: { password } });
};

export const resetUserPassword = async (id, data) => {
  const response = await api.post(`users/${id}/reset-password/`, data);
  return response.data;
};
